import { TranslateService } from "@ngx-translate/core";
import { HttpClient } from "@angular/common/http";
import { Component, Inject, OnInit } from "@angular/core";
import { Location } from "@angular/common";
import { NgxPrinterService } from "ngx-printer";
import { Account,StatementEnum  } from "../client-data";
import { UrlConstants } from "src/app/models/urlConstants";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Router } from "@angular/router";

import * as moment from "moment";
import { SystemSettingsService } from "src/app/services/systemSettings.service";

@Component({
  selector: "app-statement",
  templateUrl: "./statement.component.html",
  styleUrls: ["./statement.component.scss"],
})
export class StatementComponent implements OnInit {
  today = new Date();
  selectedStatement: any;
  statement: any;
  dateFrom: Date = new Date(this.today.setDate(this.today.getDate() - 3));
  dateTo: Date = new Date();
  selectedCurr = "1";
  isReportArabic: boolean = true
  noStatement;
  mainCode: any;
  subCode: any;
  isInvoicesLoading: boolean = false;
  accList: Object;
  selectedClient: any;
  inputUser: Account;
public maxDate: Date = new Date();

  public disableFutureDates = (d: Date | null): boolean => {
    if (!d) return true;
    const today = new Date();
    const date = new Date(d.getFullYear(), d.getMonth(), d.getDate());
    const max = new Date(today.getFullYear(), today.getMonth(), today.getDate());
    return date <= max;
  };
  tryGenerate(item) {
    // this.router.navigate(["preview-invoice"], {
    //   state: { invoice: this.selectedStatement },
    // });
    this.selectedStatement = item;

    setTimeout(() => {
      this.printerService.printDiv("print-section");
    }, 500);
  }

  selectInvoice(invoicee) {
    this.selectedStatement = invoicee;
  }

  constructor(
    private http: HttpClient,
    @Inject(MAT_DIALOG_DATA) public data: string,
    public translate: TranslateService,
    private router: Router,
    private printerService: NgxPrinterService,
    private systemSetting: SystemSettingsService,
    private location: Location
  ) {
    this.accList = JSON.parse(localStorage.getItem("accList")) as Account[];
    if (this.data != null && this.data["inputUser"] != null) {
      this.selectedClient = this.data["inputUser"];
       this.mainCode=this.data['inputUser'].MainCode
        this.subCode=this.data['inputUser'].SubCode
    } else {
      this.selectedClient = this.accList[0].relationCode;
    }
  }
  onUserChanged(event: any) {
  this.selectedClient = event.relationCode;
  this.mainCode = event.MainCode;
  this.subCode = event.SubCode;
  }
  // fetchClientStatement() {
  //   let from = moment(this.dateFrom).format("MM-DD-YYYY");
  //   let to = moment(this.dateTo).format("MM-DD-YYYY");

  //   let lang = this.translate.currentLang == "ar" ? 1 : 2;
  //   let isRated = this.selectedCurr == "-1";

  //   // 01-03-2020
  //   return this.http.get<any[]>(
  //     `${UrlConstants.backofficeUrl}/api/Client/getClientStatementPDF?fromDate=${from}&toDate=${to}&currency=${this.selectedCurr}&Rated=${isRated}&lang=${lang}&relationCode=${this.selectedClient}`
  //   );
  // }

      fetchDefaultAccount() {
        this.accList = JSON.parse(localStorage.getItem("accList")) as Account[];
        const acc = this.accList[0];
        this.selectedClient = acc.relationCode;     
        this.mainCode = acc.MainCode;
        this.subCode = acc.SubCode;
      }

  onDateChange() {
  var filter = {
      from: this.dateFrom,
      to: this.dateTo,
      currencyID: this.selectedCurr == "-1" ? null : this.selectedCurr,
      rated: this.selectedCurr == "-1" ? true : false,
      mainCode: this.mainCode,
      subCode: this.subCode,
      canceledJournals: true,
      reportStatement: StatementEnum.Client,
      // SeperateAccounts: true,
      isArabic: this.isReportArabic,
       relationCode:this.selectedClient
    }
       localStorage.setItem('reportFilter', JSON.stringify(filter))
    const routePath = this.router.serializeUrl(this.router.createUrlTree(['/generic-report/' + 'RptAccountStatement' + '/' + '0'], { queryParams: { hideNavbar: true } }))
    const url = window.location.origin + this.location.prepareExternalUrl(routePath)
    window.open(url, '_blank')
  }

  ngOnInit(): void { this.fetchSelectedCurr(); this.fetchDefaultAccount(); }
  fetchSelectedCurr(){

  this.systemSetting.checkDefaultCurr('Default Currency Client Profile').subscribe((res) => {
  if (res) {
    if(res.value=='1') {
      this.selectedCurr = "1";
    }
    else if(res.value=='2') {
      this.selectedCurr = "-1";
    }
    else{
      this.selectedCurr = "2";
    }
  }
});
}}
